export const ps_list = [
  ['114-RA', 'Pronto Soccorso Ravenna - Ospedale Santa Maria delle Croci'],
  ['114-RC', 'Pronto Soccorso Riccione - Ospedale Ceccarini'],
  ['114-CE', 'Pronto Soccorso Cesena - Ospedale Bufalini'],
  ['114-LU', 'Pronto Soccorso Lugo - Ospedale “Umberto I”'],
  ['114-FO', 'Pronto Soccorso Forlì - Ospedale Morgagni-Pierantoni'],
  ['114-FA', 'Pronto Soccorso Faenza'],
  ['114-RN', 'Pronto Soccorso Rimini - Ospedale Infermi'],
];
